// extracted by mini-css-extract-plugin
export default {"container":"styles_container__yaKJQ","header":"styles_header__vXwn3","action":"styles_action__LWhh-"};